/**
 * --------------------------------------------------
 * store module for draft message based on threadid
 * add : based on click thread
 * delete : based on leave chat, end chat
 * reset : based on logout
 * update : based on change message
 * --------------------------------------------------
 */
export const DRAFT_ADD = "draftAdd"; // --- append new draft
export const DRAFT_RESET = "draftReset"; // --- remove all draft
export const DRAFT_UPDATE = "draftUpdate"; // --- update draft index
export const DRAFT_DELETE = "draftDelete"; // --- remove specific threadid
export const DRAFT_INPUT_TOGGLE = "draftInputToggle"; // --- toggle input textarea

import Vue from "vue";
export default {
  state: {
    // --- [{threadid:xx, message: 'xxx'}, {...}]
    _draft: [],
    _ai_auto_draft_enabled: false,
  },
  getters: {
    getDraftById: (state) => (threadid) => {
      return state._draft.find((item) => item.threadid === threadid);
    },
  },
  actions: {},
  mutations: {
    // -- params : threadid, message, input_enable
    [DRAFT_ADD]: (state, params) => {
      const index = state._draft.findIndex(
        (item) => item.threadid === params.threadid
      );
      if (index === -1) {
        state._draft.push({
          threadid: null,
          message: null,
          input_enable: true, // disable input text when ask AI
          id_ask_ai: null, // diperlukan untuk audit (asumsi berpindah thread)
          ai_cancelled: false,
          is_edited_by_staff: false,
          ...params,
        });
      }
    },
    [DRAFT_UPDATE]: (state, params) => {
      const index = state._draft.findIndex(
        (item) => item.threadid === params.threadid
      );
      if (index !== -1) {
        Vue.set(state._draft, index, {
          ...state._draft[index],
          ...params,
        });
      }
    },
    [DRAFT_RESET]: (state) => {
      state._draft = [];
    },
    [DRAFT_DELETE]: (state, threadid) => {
      const index = state._draft.findIndex(
        (item) => item.threadid === threadid
      );
      if (index !== -1) {
        state._draft.splice(index, 1);
      }
    },
    [DRAFT_INPUT_TOGGLE]: (state, params) => {
      const index = state._draft.findIndex(
        (item) => item.threadid === params.threadid
      );
      if (index !== -1) {
        Vue.set(state._draft, index, {
          ...state._draft[index],
          input_enable: params.input_enable ?? true,
        });
      }
    },
  },
};
